import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../VpqClient.scss';

import BaseComponent from 'common/BaseComponent';
import CheckBox from 'common/CheckBox';
import {getMessage as msg} from 'MessageBundle'

export default class FinanceTab extends BaseComponent {

    render() {
        const {paymentBlock, dunningLocks} = this.props.value;
        return (
            <div>
                <CheckBox id="paymentBlock" label={msg("financeTab.paymentBlock")} value={paymentBlock}
                    onChange={this.props.onChange("paymentBlock")} disabled={this.props.readOnly} className={theme.checkWrap}/>
                <CheckBox id="dunningLocks" label={msg("financeTab.dunningLocks")} value={dunningLocks}
                    onChange={this.props.onChange("dunningLocks")} disabled={this.props.readOnly} className={theme.checkWrap}/>
            </div>
        );
    }
}

FinanceTab.propTypes = {

    /**
     * Function, called on finance tab data change
     */
    onChange: PropTypes.func,

    /**
     * The financeTab part of complaint with all data needed for finance Tab.
     */
    value: PropTypes.object.isRequired,

    /**
     *  Flag, showing complaint is editable or not.
     */
    readOnly: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/FinanceTab/index.js